import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const usePlanLimitStore = defineStore("planLimit", () => {
  const planLimit = ref({});
  const planConfig = ref([]);
  const paymentMethod = ref(null);
  const query = ref(null);

  const isFreePlan = computed(() => {
    return (
      planLimit.value == null ||
      planLimit.value.plan == null ||
      planLimit.value.plan.name === "Free"
    );
  });

  const usedFreePlan = computed(() => {
    return planLimit.value == null || planLimit.value.freeTrialUsed;
  });

  const isBasicPlan = computed(() => {
    return (
      planLimit.value == null ||
      planLimit.value.plan == null ||
      planLimit.value.plan.name === "Basic"
    );
  });

  const isBusinessPlan = computed(() => {
    return isFreePlan.value === false && isBasicPlan.value === false;
  });

  async function getPlanLimit() {
    if (planLimit.value && Object.keys(planLimit.value).length > 0) return;
    const res = await query.value.executeQuery({
      requestPolicy: "network-only",
    });
    if (res.data && res.data.value.brandPlanLimit) {
      planLimit.value = res.data.value.brandPlanLimit;
    }
  }

  function $reset() {
    planLimit.value = {};
    paymentMethod.value = null;
  }

  return {
    planLimit,
    planConfig,
    paymentMethod,
    query,
    getPlanLimit,
    $reset,
    isFreePlan,
    usedFreePlan,
    isBasicPlan,
    isBusinessPlan,
  };
});
